module.exports = __webpack_public_path__ + "static/media/tv.04bf00cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tv.svg
// module id = 272
// module chunks = 0